import { render, staticRenderFns } from "./MapaCompra.vue?vue&type=template&id=72339e57&v-slot%3Aitem.action=true"
import script from "./MapaCompra.vue?vue&type=script&lang=js"
export * from "./MapaCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports